import { Verb, Parse, Parser, Value } from '../../../parse';
import { Ability, Action, Handler, Entity } from '../../game';
import { Game } from '../../game/game';
import { FindUnresolved, findUnresolvedHandler } from './FindUnresolved';
import { Player } from '../../actors';

export class Find extends Action {
    id = '~find';

    item: Entity;

    constructor({ item }: { item: Entity }) {
        super();
        this.item = item;
    }

    static ability(): Ability {
        return {
            handlers: [findHandler, findUnresolvedHandler],
            parser,
            verbs: [
                new Verb('find'),
                new Verb('look for'),
                new Verb('where is'),
                new Verb('search for'),
            ],
            prepositions: [],
        };
    }
}

export const findHandler: Handler = async ({ action, runner, actor }) => {
    if (!action.is(Find) || !actor?.is(Player)) return;
    const { item } = action;

    const room = actor.location();
    if (room.contains(item)) {
        await runner.doOutput(`There is ${item.an()} here.`);
    } else if (actor.contains(item)) {
        await runner.doOutput(`You are carrying ${item.an()}.`);
    } else if (actor.hasItem(item)) {
        const container = item.container()!;
        await runner.doOutput(
            `It is in ${container.the()}, which you are carrying.`
        );
    } else if (room.hasItem(item)) {
        const container = item.container()!;
        await runner.doOutput(
            `It is in ${container.the()}, which is in the room.`
        );
    }
    return Action.complete();
};

const parser = (game: Game): Parser<Value, FindUnresolved> => {
    const find = Parse.words(Find.ability().verbs);
    const findObject = find.chain((_verb) =>
        Parse.target(game.lexicon).after(Parse.whitespace())
    );
    return Parse.any(
        // find
        find.into(new FindUnresolved({ item: undefined })),
        // find button
        findObject.map((item) => new FindUnresolved({ item }))
    );
};
